import { User } from 'oidc-client-ts';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  oauthManager,
  oauthProviderSpecificManager,
  validateGoogleUserInfoFromQueryParams,
} from '@/utils/backend-auth.tsx';
import { mixedLoginMethods } from '@/utils/constants';

export const OauthCallback = () => {
  const navigate = useNavigate();

  const navPostCallback = () => {
    window.history.replaceState(
      {},
      window.document.title,
      window.location.origin
    );
    let returnUrl = localStorage.getItem('returnUrl');
    if (returnUrl) {
      localStorage.removeItem('returnUrl');
    } else {
      returnUrl = '/';
    }
    if (returnUrl.includes('oauth-callback')) {
      returnUrl = '/';
    }
    navigate(returnUrl, { replace: true });
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    // If there is an error, log the error and redirect to home
    if (queryParams.get('error')) {
      console.error(
        'Error from oauth server:',
        queryParams.get('error'),
        queryParams.get('error_description')
      );
      navigate('/', { replace: true });
      return;
    }
    // If not a redirect from the oauth server, do nothing and redirect to home
    if (!queryParams.get('code') && !queryParams.get('user')) {
      navigate('/', { replace: true });
      return;
    }

    if (mixedLoginMethods.customOidc) {
      // For google oauth, read the user info from the query params and store it in local storage
      const userb64 = validateGoogleUserInfoFromQueryParams(queryParams);
      if (!userb64) {
        console.error(
          'No user returned from google oauth, check your oauth settings'
        );
        navigate('/', { replace: true });
        return;
      }
      // store the user info in local storage and set the session
      localStorage.setItem('ls:auth:custom-oidc', userb64);
      oauthProviderSpecificManager?.setUserInfo();
      navPostCallback();
    } else {
      // For oauth providers supporting PKCE, use the oauth manager
      oauthManager?.signinCallback().then((user: User | void) => {
        if (!user) {
          console.error(
            'No user returned from signinCallback, check your oauth settings'
          );
          navigate('/', { replace: true });
          return;
        }
        oauthManager?.storeUser(user).then(
          () => {
            navPostCallback();
          },
          (error) => {
            console.error(error);
          }
        );
      });
    }
  }, []);

  return <div>Loading ...</div>;
};

export default OauthCallback;
